export enum AssetEventProgressEvent {
  KeepAlive = "AssetEventProgressKeepAlive",
  Play = "AssetEventProgressPlay",
  Pause = "AssetEventProgressPause",
  Seek = "AssetEventProgressSeek",
  Stop = "AssetEventProgressStop",
}
